import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";

type GetLineItemQuantityAlreadyValidatedByMerchantParams = {
  lineItem: ReturnRequestLineItemDto;
};

/**
 * For a given Line Item, returns the quantity that has already been validated by the merchant.
 * To get it, we look at any action that has been done by the merchant on the line item
 * that has the status "ok" and we sum the quantity of all these actions.
 */
export function getLineItemQuantityAlreadyValidatedByMerchant({
  lineItem,
}: GetLineItemQuantityAlreadyValidatedByMerchantParams) {
  return lineItem.merchant_informations.reduce((acc, merchantInformation) => {
    if (merchantInformation.status === "ok") {
      return acc + merchantInformation.quantity;
    }
    return acc;
  }, 0);
}
